import { Box, Pagination, Stack, Typography } from '@mui/material';
import React from 'react';

interface IProps {
	total: number;
	currentPage: number;
	perPage: number;
	onPageChange: (page: number) => void;
}

export const ClientTablePagination: React.FC<IProps> = ({ total, currentPage, perPage, onPageChange }) => {
	const totalPages = Math.ceil(total / perPage);
	const shouldRender = totalPages > 1;

	if (!shouldRender) {
		return null;
	}

	const startItem = currentPage * perPage + 1;
	const endItem = Math.min(startItem + perPage - 1, total);

	return (
		<Stack
			className="BasicTable-TablePagination"
			direction="row"
			justifyContent="space-between"
			alignItems="center"
		>
			<Box width="30%">
				<Typography className="BasicTable-TablePaginationResults">
					Showing {startItem} - {endItem} from {total}
				</Typography>
			</Box>

			<Box width="40%">
				<Pagination
					className="BasicTable-TablePaginationPages"
					shape="rounded"
					count={totalPages}
					page={currentPage + 1}
					onChange={(_, page) => onPageChange(page - 1)}
				/>
			</Box>

			<Box width="30%" />
		</Stack>
	);
};

export default ClientTablePagination;
